// src/components/Settings/PrintSettings.jsx
import React from 'react';

export default function PrintSettings({ settings, onUpdate, loading }) {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Print Settings</h3>
      <div className="space-y-4">
        <label className="flex items-center space-x-2">
          <input type="checkbox" className="rounded" defaultChecked />
          <span>Auto-print receipt after sale</span>
        </label>
        <label className="flex items-center space-x-2">
          <input type="checkbox" className="rounded" />
          <span>Show company logo on receipts</span>
        </label>
        <label className="flex items-center space-x-2">
          <input type="checkbox" className="rounded" defaultChecked />
          <span>Show VAT breakdown on receipts</span>
        </label>
      </div>
    </div>
  );
}